import React from "react";

import JobPage from "./JobPage";

const ProjectManager = () => (
    <JobPage
        title="Project Manager"
        location="Malta"
        summary={[
            "Manage project schedules and report status to stakeholders.",
            "Work closely with the product development team to track progress and improve overall delivery.",
            "Understand and manage our project management tools (e.g. Shortcut).",
            "Have a firm understanding of agile methodology and be able to perform the role of a scrum master.",
            "Coordinate with other departments to remove blockers.",
        ]}
        tldrIntro="Don't read this unless you know"
        tldr={[
            "The modern software development process.",
            "Agile development methodologies and artifacts.",
            "Project management kung-fu (black belt level).",
            "How to work effectively on a distributed team.",
            "How to hit deadlines.",
        ]}
        requirements={[
            "5+ years' experience in software development project management.",
            "Familiarity with modern software engineering tools (build tools, unit testing, test automation, CI, etc.). You may not code, but familiarity with the SDLC is a must.",
            "Experience in banking, payment processing, forex, brokerage services, and/or crypto.",
            "Proven track record of delivering on time, to specification.",
            "Experience with Agile methodologies and DevOps.",
            "Self-starter with a can-do attitude.",
            "BS or higher.",
        ]}
        experienceNeeded={[
            "Project management in software development.",
            "Kanban-style job boards, agile stories, scrum processes and artifacts.",
            "Continuous process refinement.",
        ]}
        desiredExperience={["Web3 experience is a plus.", "CPM or PMP a plus."]}
    />
);

export default ProjectManager;
